import ServiceRequestError from "Services/ServiceRequestError";
import { HttpRequestBodyType } from 'ts-common-utils';

export default class HttpRequestOptions {
    bodyObject?: any;
    sendAs: HttpRequestBodyType = HttpRequestBodyType.JSON;
    onSuccess?: ((json: any) => void);
    onFailure?: ((error: ServiceRequestError) => void);
    timeout: number = 0;

    public constructor(init?: Partial<HttpRequestOptions>) {
        if (init != undefined) {
            Object.shallowMerge(this, init);
        }
    }
}